import { createI18n } from '@learnforge/i18n';
import { locales, type ProbKey } from './locales';

export const i18n = createI18n<ProbKey>({
  gameId: 'probability',
  locales,
});
